<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box account_input">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box">
            <div style="display: flex" class="font_size_12"></div>
            <div class="Addcompanies">
              <el-button class="btn_export" @click="CollectCheckBook">{{
                $t("DataManagement.UploadCompanies")
              }}</el-button>

              <el-button
                :class="
                  $store.state.app.changeList.length == 0
                    ? ' btn_export btn_exporthui'
                    : 'btn_export'
                "
                :disabled="$store.state.app.changeList.length == 0"
                @click="RescanCheckBook"
                >{{ $t("DataManagement.RiskScan") }}</el-button
              >
            </div>
          </div>
          <div class="his_sel_box" style="width: 100%">
            <el-table
              class="spec_table table_height_30 table_font_size_14"
              :data="yourUsagelist"
              style="width: 100%"
              empty-text="No Data"
              @selection-change="handleSelectionChange"
              :row-key="(row) => row.aaa_id"
              :key="refresh"
            >
              <el-table-column
                v-if="isOpenSlct"
                type="selection"
                :selectable="selectableRows"
                width="40 "
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                :label="$t('DataManagement.Date')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.updateTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                width="350"
                class-name="company  company_link_tooltip_normal"
                :label="$t('DataManagement.CompanyName')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    class="table-content company_link"
                    v-if="scope.row.aaaid"
                    @click="setid(scope.row)"
                  >
                    {{ scope.row.companyName }}
                  </span>
                  <span class="table-content" v-else>
                    {{ scope.row.companyName }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                prop="Country"
                :label="$t('DataManagement.Country')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.countryName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyTypeEn"
                :label="$t('DataManagement.CompanyType')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.companyTypeEn
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyStatusEn"
                :label="$t('DataManagement.CompanyStatus')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.companyStatusEn
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyDqi"
                :label="$t('DataManagement.DQI')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.companyDqi
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="uploadResultEn"
                :label="$t('DataManagement.Uploaded')"
                width="135"
                align="left"
              >
                <template slot-scope="scope">
                  <span class="table-content">{{
                    scope.row.uploadResultEn
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label=" " align="center" width="120">
                <template slot-scope="scope">
                  <span class="table-content flex_center">
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      v-if="scope.row.uploadResult == 1"
                      :visible-arrow="false"
                      effect="light"
                      :content="$t('DataManagement.Download')"
                      placement="top"
                    >
                      <svg
                        t="1723022129119"
                        class="icon"
                        @click="Down(scope.row)"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="6324"
                        width="28"
                        height="28"
                      >
                        <path
                          d="M491.52 858.112l-108.544-106.496c-8.192-8.192-20.48-8.192-28.672 0-8.192 8.192-8.192 20.48 0 28.672l139.264 135.168c0 2.048 2.048 6.144 4.096 8.192 4.096 4.096 10.24 6.144 16.384 6.144 6.144 0 12.288-2.048 16.384-6.144 2.048-2.048 4.096-4.096 4.096-8.192l139.264-135.168c8.192-8.192 8.192-20.48 0-28.672-8.192-8.192-20.48-8.192-28.672 0l-110.592 108.544v-368.64c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48v366.592z m-399.36-344.064v-307.2c0-45.056 36.864-81.92 81.92-81.92h675.84c45.056 0 81.92 36.864 81.92 81.92v307.2c0 45.056-36.864 81.92-81.92 81.92h-96.256c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h96.256c67.584 0 122.88-55.296 122.88-122.88v-307.2c0-67.584-55.296-122.88-122.88-122.88h-675.84c-67.584 0-122.88 55.296-122.88 122.88v307.2c0 67.584 55.296 122.88 122.88 122.88v-40.96h-4.096v40.96h102.4c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-98.304c-45.056 0-81.92-36.864-81.92-81.92z m296.96-237.568c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48h245.76c12.288 0 20.48-8.192 20.48-20.48s-8.192-20.48-20.48-20.48h-245.76z"
                          fill="#1296db"
                          p-id="6325"
                        ></path>
                      </svg>
                    </el-tooltip>
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      v-else
                      :visible-arrow="false"
                      effect="light"
                      :content="$t('DataManagement.Match')"
                      placement="top"
                    >
                      <svg
                        @click="addCompanyDilag(scope.row)"
                        t="1763532604966"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8049"
                        width="28"
                        height="28"
                      >
                        <path
                          d="M510.759 0C228.679 0 0 228.677 0 510.748c0 117.224 39.911 224.892 106.318 311.091l38.377-39.956C95.222 715.203 63.249 634.79 56.233 547.225l220.465 0c16.665 107.625 105.717 190.467 215.8 198.984l0 219.895c-83.913-3.356-161.914-29.321-228.223-72.049l-34.636 42.919c80.66 53.305 177.202 84.525 281.12 84.525 282.078 0 510.748-228.672 510.748-510.752C1021.507 228.677 792.836 0 510.759 0zM492.498 691.544c-79.903-8.023-144.782-66.934-160.493-144.319l160.493 0L492.498 691.544zM492.498 492.502l-162.33 0c8.664-85.968 76.465-153.749 162.33-162.437L492.498 492.502zM492.498 274.489c-116.356 8.884-209.087 101.64-217.971 218.013L55.647 492.502C65.055 255.277 255.29 65.046 492.498 55.623L492.498 274.489zM547.221 56.52C775.889 74.679 956.69 261.363 965.857 492.502L746.951 492.502c-8.415-110.212-92.072-199.151-199.73-215.836L547.221 56.52zM547.221 332.187c77.128 15.798 136.044 80.477 144.089 160.315L547.221 492.502 547.221 332.187zM547.221 547.225l142.252 0c-14.502 71.43-70.847 127.4-142.252 141.949L547.221 547.225zM547.221 965.024 547.221 744.544c101.593-15.785 181.821-95.668 197.559-197.318l220.158 0C947.26 769.922 769.872 947.353 547.221 965.024z"
                          p-id="8050"
                          fill="#1296db"
                        ></path>
                      </svg>
                    </el-tooltip>
                    <el-tooltip
                      class="tbl_opr_tip flex_center"
                      :visible-arrow="false"
                      effect="light"
                      :content="$t('DataManagement.Delete')"
                      placement="top"
                    >
                      <svg
                        @click="ClealCompanyDila(scope.row)"
                        t="1763435921214"
                        class="icon margin-left20"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="8222"
                        width="32"
                        height="32"
                      >
                        <path
                          d="M386.990351 752.645802L386.990351 359.958188c0-9.866718-8.003606-17.84953-17.851285-17.84953-9.849726 0-17.850261 7.982812-17.850261 17.84953l0 392.687614c0 9.850345 8.000536 17.851577 17.850261 17.851577C378.986745 770.497379 386.990351 762.496148 386.990351 752.645802zM529.793466 752.645802L529.793466 359.958188c0-9.866718-8.003606-17.84953-17.853331-17.84953-9.846656 0-17.848215 7.982812-17.848215 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.848215 17.851577C521.788837 770.497379 529.793466 762.496148 529.793466 752.645802zM815.393554 324.259128c-9.845632 0-17.846168 7.983835-17.846168 17.84953l0 481.935264c0 19.697621-15.987768 35.700083-35.702569 35.700083L262.038521 859.744006c-19.715825 0-35.700523-16.002462-35.700523-35.700083L226.337999 342.109682c0-9.866718-8.001559-17.84953-17.850261-17.84953-8.3014 0-15.271424 5.681396-17.26286 13.373589-0.194436-0.107447-0.396036-0.204661-0.588425-0.316202l0 486.72843c0 39.429011 31.953022 71.39812 71.401046 71.39812l499.806295 0c39.430627 0 71.401046-31.969109 71.401046-71.39812L833.244839 342.109682C833.245862 332.242963 825.244303 324.259128 815.393554 324.259128zM869.04872 199.312418L663.473431 199.312418l-65.856545-65.853847c-3.810948-3.811816-8.844798-5.641487-13.840783-5.52176-0.146339-0.00307-0.287561-0.021489-0.4339-0.021489L440.541135 127.915321c-0.128942 0-0.254814 0.016373-0.382732 0.019443-4.979612-0.105401-9.991971 1.726318-13.789616 5.523807l-65.856545 65.853847L154.93593 199.312418c-9.848702 0-17.849238 7.984858-17.849238 17.850553 0 9.849322 8.000536 17.850553 17.849238 17.850553l214.203137 0c0.225137 0 0.444133-0.025583 0.667223-0.033769 5.0799 0.190335 10.221201-1.633197 14.097644-5.508457l65.856545-65.85487 124.462669 0 65.856545 65.85487c3.875419 3.876284 9.017744 5.698792 14.09662 5.508457 0.224113 0.008186 0.44311 0.033769 0.667223 0.033769l214.202113 0c9.848702 0 17.849238-8.001231 17.849238-17.850553C886.898981 207.297276 878.897422 199.312418 869.04872 199.312418zM672.592487 752.645802L672.592487 359.958188c0-9.866718-7.998489-17.84953-17.848215-17.84953s-17.851285 7.982812-17.851285 17.84953l0 392.687614c0 9.850345 8.001559 17.851577 17.851285 17.851577S672.592487 762.496148 672.592487 752.645802z"
                          fill="#F56B6B"
                          p-id="8223"
                        ></path>
                      </svg>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <template slot="empty">
                <div>
                  <img
                    style="width: 50%; height: 50%"
                    src="../../../../assets/images/noDate.png"
                    alt=""
                  />
                </div>
              </template>
            </el-table>
            <div class="page_i_box" v-if="yourUsagelist.length > 0">
              <Page
                :totalFont="true"
                :total="page.total"
                :pageSize.sync="page.pageSize"
                :currentPage="page.pageNo"
                @onPageChange="onPageChangeList"
              ></Page>

              <div class="search_rsult_txt line_2">
                {{ page.pageNo }}-{{ page.pageSize }} of over
                <span
                  class="foundOverNum"
                  :style="{ color: $store.state.app.themeColor }"
                  >&nbsp;{{ page.total | FilterNum }}&nbsp;</span
                >
                results for "{{ $t("DataManagement.CompaniesUploaded") }}"
              </div>
            </div>
            <!-- <div v-if="this.page.total>this.page.pageSize" style="text-align: center; padding-top: 20px">
              <span class="contclass show_All" @click="apptablelist">Show More</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <addCompany
      :addDialog="addDialog"
      @closeAdd="closeAdd"
      :ComID="Companid"
      :CompanyName="CompanyNameEn"
    ></addCompany>
    <UpdateFile
      :isUploaded="true"
      :UpdateFileDialog="UpdateFileDialog"
      @closeUpDownDialog="closeUpDownDia"
    ></UpdateFile>

    <!-- 提示选择多少条 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="riskScanDialogVisible2"
      :before-close="
        () => {
          riskScanDialogVisible2 = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_550"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/risk_search_icon.png" />
        </div>
        <div class="dialog_title_img_text">{{ $t("RiskScan.Scanning") }}</div>
        <div class="risk_text">
          {{ $t("RiskScan.Youhaveselectedatotalof") }}
          <span class="num">{{ riskScanDialogLength }}</span>
          {{ $t("RiskScan.Tostartriskscanning") }}
        </div>
      </div>

      <div slot="footer" class="dialog_footer dialog_footer_display">
        <!-- <el-button
          @click="riskScanDialogVisible2 = false"
          class="risk_cancel_btn"
          type="cancel"
          >{{ $t("RiskScan.Cancel") }}</el-button
        > -->
        <el-button
          @click="confirmSanCheck"
          class="risk_primary_btn"
          type="primary"
          >{{ $t("RiskScan.Confirm") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import {
  getUserCompanyActionPage,
  downloadOnlinePdf,
  deleteById,
} from "@/api/userApi";
import Page from "@/components/page/index.vue";
import addCompany from "../adCppany/addCompany.vue";
import UpdateFile from "../adCppany/UpdateFile.vue";
export default {
  mixins: [mixins1],
  components: {
    Page,
    addCompany,
    UpdateFile,
  },
  props: {
    isOpenSlct: {
      type: Boolean,
    },
  },
  watch: {
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        // 在这里处理columns属性的变化
        if (newVal == false) {
          this.handleSelectionChange([]);

          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
        }
        this.refresh++;

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      riskScanDialogVisible2: false,
      riskScanDialogLength: 0,
      reLoginVis: false,
      UpdateFileDialog: false,
      CompanyNameEn: "",
      Companid: null,
      addDialog: false,
      parentTable: [],
      checkList: [],
      menuActive: 1,
      datePicker: [],
      CategoryVal: "",
      compareList: [],
      yourUsagelist: [],
      window: window,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      compareListParent: [],
      refresh: 0,
      chosenList: [],
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: true,
    });
    this.getgetUserActionLogPage();
  },

  methods: {
    selectableRows(row, index) {
      return row.aaaid;
    },
    closeUpDownDia(val) {
      this.UpdateFileDialog = val;
    },
    ClealCompanyDila(val) {
      deleteById({
        id: val.id,
      }).then((res) => {
        if (res.code == 200) {
          this.getgetUserActionLogPage();
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    closeAdd(val) {
      this.addDialog = val;
    },
    addCompanyDilag(val) {
      this.CompanyNameEn = val.companyName;
      this.Companid = val.id;
      this.addDialog = true;
    },
    handleSelectionChange(val) {
      console.log(77777, val);
      this.compareListParent = val;
      this.chosenList = val;
      this.cheeckbooksUpdate(val);
    },

    cheeckbooksUpdate(val) {
      this.compareList = [...this.compareListParent];
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: this.compareList.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: this.compareList.length > 0,
      });
      // 添加 选中公司
      this.$store.dispatch("app/setchangeList", this.compareList);
      this.compareList.map((item) => {
        item.aaa_id = item.aaaid;
      });

      //添加 选中公司 风险扫描
      sessionStorage.setItem("riskScanList", JSON.stringify(this.compareList));
    },
    CollectCheckBook() {
      this.UpdateFileDialog = true;
    },
    //扫描确认
    confirmSanCheck() {
      this.riskScanDialogVisible2 = false;
      this.aaaidList = [];
      this.$store.state.app.changeList.map((item) => {
        this.aaaidList.push(item.aaa_id);
      });
      //跳转
      let routeData = this.$router.resolve({
        path: "/riskScanning/index",
        query: { aaaids: this.aaaidList.join("@@") },
      });
      window.open(routeData.href, "_blank");
    },
    //Rescan
    RescanCheckBook() {
      if (this.$store.state.app.changeList.length == 0) return;
      this.riskScanDialogVisible2 = true;
      this.riskScanDialogLength = this.$store.state.app.changeList.length;
    },
    MenuClick(item) {
      this.menuActive = item.value;
    },
    setid(row) {
      let companyCountryEn = "";

      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaid +
          "/background/snapshot?id3a=" +
          row.aaaid +
          "&companyCountry=" +
          "" +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    Down(scope) {
      downloadOnlinePdf(scope.aaaid).then((res) => {
        const binaryData = [];
        binaryData.push(res);
        let pdfUrl = window.URL.createObjectURL(
          new Blob(binaryData, { type: "application/pdf" }),
        );
        window.open(pdfUrl, "_blank");
      });
    },
    getgetUserActionLogPage() {
      let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;
      getUserCompanyActionPage({
        userId: userinfo.id,
        type: "3",
        portfolioId: "",
        companyName: "",
        companyIsicEn: "",
        companyTypeEn: "",
        companyStatusEn: "",
        startTime: "",
        endTime: "",

        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
        .then((res) => {
          if (res.code == 200) {
            this.yourUsagelist = res.data.rows;
            this.page.total = res.data.total;
          } else {
            this.yourUsagelist = [];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    onPageChangeList({ page, size }) {
      this.handleSelectionChange([]);
      this.page.pageSize = size;
      this.page.pageNo = page;
      this.getgetUserActionLogPage();
    },
    currtentPageChange(pageSize) {
      this.handleSelectionChange([]);
      this.page.pageSize = pageSize;
      this.getgetUserActionLogPage();
    },
    apptablelist() {
      this.page.pageSize = this.page.pageSize + 5;
      this.getgetUserActionLogPage();
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}
.form-email {
  display: flex;
  width: 100%;
}
.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}
.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}
.item_txtcolor2 {
  color: #55b419;
}
.item_txtcolor3 {
  color: #ffa000;
}
.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}
.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}
.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}
.das_top_item .color4 {
  background: #ff7600;
}
.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}
.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}
.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}
.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}
.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}
.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.title {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold" !important;
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc;
  border-radius: 0.5714285714285714rem;
  font-size: 1.1428571428571428rem;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem
    rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}
.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}
.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold" !important;
}
.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}
.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}
/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}
/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 1.4285714285714286rem;
  color: #8c939d;
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}
/deep/ .avatar {
  width: 5rem;
  height: 5rem;
  display: block;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

.Addcompanies {
  margin-bottom: 14px;
  display: flex;
  gap: 20px;
}

.el-button {
  margin-left: 0px;
}

@media screen and (max-width: 1920px) {
  .btn_blue {
    font-size: 14px;
    width: max-content;
  }
  .Addcompanies {
    margin-bottom: 10px;
    gap: 15px;
  }

  ::v-deep .el-table td.el-table__cell {
    height: 50px !important;
  }
  ::v-deep .el-table th.el-table__cell > .cell {
    padding-left: 15px;
    padding-right: 15px;
  }
}

@media screen and (max-width: 1439px) {
  .btn_blue {
    font-size: 12px;
    width: max-content;
  }
  .Addcompanies {
    margin-bottom: 10px;
    gap: 13px;
  }
}
</style>
